import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

// import Can from '../../../features/components/Can'
import DateRangeWithStaticList from '../../../features/components/DateRange/DateRangeWithStaticList'
// import CampaignFacebookCreate from '../../../forms/Facebook/CampaignForms/CampaignFacebookCreate'
// import CampaignGoogleCreate from '../../../forms/Google/CampaignForms/CampaignGoogleCreate'
// import CampaignDv360Create from '../../../forms/DV360/CampaignForms/CampaignDv360Create'
// import CampaignTikTokCreate from '../../../forms/Tiktok/CampaignForms/CampaignTikTokCreate'
import ExportAsCsvReport from '../../../forms/Facebook/ExportAsCsvReport'
//
// import usePlatformConnected from '../../../features/hooks/usePlatformConnected'

import { setCampaignsDateRange } from '../../../modules/actions/campaigns'
import { campaignsDateRangeSelector, campaignsSelector } from '../../../modules/selectors/campaigns'

import { FACEBOOK_PLATFORM } from '../../../constants/selectLists/platformList'

// import {
//   DV_360_PLATFORM,
//   FACEBOOK_PLATFORM,
//   GOOGLE_PLATFORM,
//   TIKTOK_PLATFORM
// } from '../../../constants/selectLists/platformList'

function CampaignsActions({ selectedPlatform, selectedCampaigns }) {
  const campaigns = useSelector(campaignsSelector)

  const campaignsIds = useMemo(() => campaigns.map(campaign => campaign.id), [campaigns])

  // const CampaignCreateForm = useMemo(() => {
  //   if (selectedPlatform === FACEBOOK_PLATFORM) {
  //     return <CampaignFacebookCreate />
  //   } else if (selectedPlatform === GOOGLE_PLATFORM) {
  //     return <CampaignGoogleCreate />
  //   } else if (selectedPlatform === DV_360_PLATFORM) {
  //     return <CampaignDv360Create />
  //   } else if (selectedPlatform === TIKTOK_PLATFORM) {
  //     return <CampaignTikTokCreate />
  //   }
  // }, [selectedPlatform])
  //
  // const isPlatformConnected = usePlatformConnected(selectedPlatform)

  return (
    <>
      {selectedPlatform === FACEBOOK_PLATFORM && (
        <ExportAsCsvReport
          dateRangeSelector={campaignsDateRangeSelector}
          campaignsIds={selectedCampaigns.length ? selectedCampaigns : campaignsIds}
          level="campaign"
        />
      )}
      <DateRangeWithStaticList
        setDateRangeAction={setCampaignsDateRange}
        dateRangeSelector={campaignsDateRangeSelector}
      />
      {/* We hide new campaign form on campaigns page for now PBR-1084 */}
      {/*{isPlatformConnected && (*/}
      {/*  <Can I="create" a="Campaign">*/}
      {/*    {CampaignCreateForm}*/}
      {/*  </Can>*/}
      {/*)}*/}
    </>
  )
}

CampaignsActions.propTypes = {
  selectedPlatform: PropTypes.string.isRequired,
  selectedCampaigns: PropTypes.array
}

export default CampaignsActions
